import { useContext, useCallback, useReducer } from 'react';
import { FilterContext } from './FilterProvider';

function useForceUpdate() {
  const negate = useCallback(state => !state, []);
  const [, forceUpdate] = useReducer(negate, true);
  return forceUpdate;
}

export function useSelectedFilters() {
  const {
    filterRegistry,
    removeSelected,
    resetAllFilters,
    getSelectedFilters,
    subscribeToRegistry,
  } = useContext(FilterContext);

  const forceUpdate = useForceUpdate();
  subscribeToRegistry(forceUpdate);

  const selectedFilters = getSelectedFilters();

  return {
    selectedFilters,
    removeOne: removeSelected,
    removeAll: resetAllFilters,
    hasSelected: selectedFilters.length > 0,
    renderSelected: selected =>
      filterRegistry.get(selected.type).renderSelected(selected.data),
  };
}
